module.exports = __webpack_public_path__ + "1f117c720dadcf05ffd54c1ef9dd17d5.svg";